export enum TRIAL_SHOW_CASE_COURSES {
  MARKETING = 'marketing',
  GESTAO_RH = 'gestao-de-recursos-humanos',
  GESTAO_FINANCEIRA = 'gestao-financeira',
  ADM = 'administracao',
  CIENCIA_COMPUTACAO = 'ciencia-da-computacao',
  SISTEMAS_INFORMACAO = 'sistemas-de-informacao',
  ENG_COMPUTACAO = 'engenharia-da-computacao',
  ADS = 'analise-e-desenvolvimento-de-sistemas',
  JOGOS_DIGITAIS = 'jogos-digitais',
  // only for test
  ENGENHARIA_DA_FERA = 'engenharia-da-fera-22',
  ENGENHARIA_DE_SOFTWARE = 'engenharia-de-software',
}
